/**
 * Represents button that opens dialog with confirmation
 * request to delete specified seminar.
 *
 * @flow
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import withModal from '../../../lib/withModal';
import DeleteSeminarDialog from './DeleteSeminarDialog';

import type { Seminar, ModalDialogTrigger } from '../../../type';

type DeleteSeminarButtonProps = {
    seminar: Seminar,
} & ModalDialogTrigger;

const DeleteSeminarButton = ({
    seminar,
    open,
    onOpen,
    onClose,
}: DeleteSeminarButtonProps) => (
    <DeleteSeminarDialog
        trigger={
            <a onClick={onOpen}>
                <FormattedMessage
                    id="pages.seminars.DeleteSeminarButton.label"
                    defaultMessage="Delete"
                />
            </a>
        }
        seminar={seminar}
        open={open}
        onClose={onClose}
    />
);

export default withModal(DeleteSeminarButton);
